
import Road from './road.js';
import { SharedBigRoad } from './shared-big-road.js';
import {RoundResult} from '../round-result.js';

//export const enum DownRoadGap {
//  BigEyeRoadGap = 1,
//  SmallRoadGap = 2,
//  CockroachRoadGap = 3,
//}

function generateDownRoadData(bigRoadGraph, rowGap) {
    const maxColumnCount = Math.max(0, ...bigRoadGraph.map(row => row.length));
    const downGraphArr = [];
    const indexArr = [];
    const lengthArr = [];
    let beginIndex;
    {
        const item1 = bigRoadGraph[1][rowGap];
        const item2 = bigRoadGraph[0][rowGap + 1];
        if (typeof item1 !== 'undefined') {
            beginIndex = item1.order;
        }
        else if (typeof item2 !== 'undefined') {
            beginIndex = item2.order;
        }
        else {
            return downGraphArr;
        }
    }
    for (let columnIndex = 0; columnIndex < maxColumnCount; columnIndex++) {
        let currentLength = 0;
        for (let rowIndex = 0; rowIndex < bigRoadGraph.length; rowIndex++) {
            const item = bigRoadGraph[rowIndex][columnIndex];
            if (typeof item !== 'undefined') {
                currentLength += 1;
                indexArr.push({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    gameResult: bigRoadGraph[rowIndex][columnIndex].gameResult,
                    order: item.order,
                });
            }
        }
        lengthArr.push(currentLength);
    }
    indexArr.sort((a, b) => a.order - b.order);

    const lengthArr2 = [];
    
    let preGameRsult;
    let cnt = 0;
    for(let i = 0; i < indexArr.length; ++i)
    {
        if(i == 0)
        {
            preGameRsult = indexArr[i].gameResult;
            cnt = 1;
        }
        else if(preGameRsult !== indexArr[i].gameResult)
        {
            lengthArr2.push(cnt);
            preGameRsult = indexArr[i].gameResult;
            cnt = 1;
        }
        else
        {
            cnt +=1;
        }
    }
    lengthArr2.push(cnt);

    let first = true;
    indexArr.forEach(item => {
        if (item.order >= beginIndex) {
            if (item.rowIndex === 0) {
                let repetition = lengthArr2[item.columnIndex - rowGap - 1] === lengthArr2[item.columnIndex - 1] ? true : false;;

                downGraphArr.push({
                    order: item.order,
                    repetition: repetition,
                });
            }
            else {
                let lastItem = bigRoadGraph[item.rowIndex - 1][item.columnIndex - rowGap];
                if(typeof lastItem !== 'undefined' && lastItem.gameResult !== item.gameResult)
                {
                    lastItem = undefined;
                }

                const targetItem = bigRoadGraph[item.rowIndex][item.columnIndex - rowGap];
                const prevColItem = bigRoadGraph[item.rowIndex][item.columnIndex - 1];
                const prevRowItem = bigRoadGraph[item.rowIndex - 1][item.columnIndex];
                let repetition = typeof lastItem === 'undefined' || typeof targetItem !== 'undefined'; 
                if(repetition === true &&
                    typeof targetItem !== 'undefined')
                {
                    if(targetItem.gameResult !== bigRoadGraph[item.rowIndex][item.columnIndex].gameResult&& lengthArr2.length > item.columnIndex - rowGap)
                    {
                        if(lengthArr2[item.columnIndex - rowGap] + 1 === item.rowIndex + 1)
                        { 
                            repetition = false;
                        }
                        else
                        {
                            repetition = true;
                        }
                    }
                }

                if(typeof prevColItem !== 'undefined' &&
                    //repetition === true &&
                    item.order -1 === prevColItem.order)
                {
                    let columnIndex;
                    let originOrder = item.order;
                    let mius = 2;
                    let tempcnt = 1;
                    while(true)
                    {
                        if(item.columnIndex - mius < 0 ||
                            originOrder - mius < 0)
                        {
                            break;
                        }

                        columnIndex = item.columnIndex - mius;

                        const tempItem = bigRoadGraph[item.rowIndex][columnIndex];       
                        if(typeof tempItem  === 'undefined')
                        {
                            break;
                        }

                        if(originOrder - mius !== tempItem.order)
                        {
                            break;
                        }

                        tempcnt += 1;
                        mius += 1;
                    }

                    tempcnt += (item.rowIndex + 1);

                    if(lengthArr2[columnIndex + 1 - rowGap] + 1 === tempcnt)
                    { 
                        repetition = false;
                    }
                    else
                    {
                        repetition = true;
                    }

                }
             
                downGraphArr.push({
                    order: item.order,
                    repetition:repetition,
                    //repetition: typeof lastItem === 'undefined' ||
                    //    typeof targetItem !== 'undefined',
                });
            }
        }
    });
    return downGraphArr;
}

function generateNewDownRoadData(smalloadGraph, rowGap) {
    const maxColumnCount = Math.max(0, ...smalloadGraph.map(row => row.length));
    const downGraphArr = [];
    const indexArr = [];
    const lengthArr = [];
    let beginIndex;
    {
        const item1 = smalloadGraph[1][rowGap];
        const item2 = smalloadGraph[0][rowGap + 1];
        if (typeof item1 !== 'undefined') {
            beginIndex = item1.order;
        }
        else if (typeof item2 !== 'undefined') {
            beginIndex = item2.order;
        }
        else {
            return downGraphArr;
        }
    }
    for (let columnIndex = 0; columnIndex < maxColumnCount; columnIndex++) {
        let currentLength = 0;
        for (let rowIndex = 0; rowIndex < smalloadGraph.length; rowIndex++) {
            const item = smalloadGraph[rowIndex][columnIndex];
            if (typeof item !== 'undefined') {
                currentLength += 1;
                indexArr.push({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    repetition: smalloadGraph[rowIndex][columnIndex].repetition,
                    order: item.order,
                });
            }
        }
        lengthArr.push(currentLength);
    }
    indexArr.sort((a, b) => a.order - b.order);

    const lengthArr2 = [];
    
    let preGameRsult;
    let cnt = 0;
    for(let i = 0; i < indexArr.length; ++i)
    {
        if(i == 0)
        {
            preGameRsult = indexArr[i].repetition;
            cnt = 1;
        }
        else if(preGameRsult !== indexArr[i].repetition)
        {
            lengthArr2.push(cnt);
            preGameRsult = indexArr[i].repetition;
            cnt = 1;
        }
        else
        {
            cnt +=1;
        }
    }
    lengthArr2.push(cnt);

    indexArr.forEach(item => {
        if (item.order >= beginIndex) {
            if (item.rowIndex === 0) {
                let repetition = lengthArr2[item.columnIndex - rowGap - 1] === lengthArr2[item.columnIndex - 1] ? true : false;;

                downGraphArr.push({
                    order: item.order,
                    repetition: repetition,
                });
            }
            else {
                const lastItem = smalloadGraph[item.rowIndex - 1][item.columnIndex - rowGap];
                const targetItem = smalloadGraph[item.rowIndex][item.columnIndex - rowGap];
                const prevColItem = smalloadGraph[item.rowIndex][item.columnIndex - 1];
                const prevRowItem = smalloadGraph[item.rowIndex - 1][item.columnIndex];
                let repetition = typeof lastItem === 'undefined' || typeof targetItem !== 'undefined'; 
                if(typeof prevColItem !== 'undefined' &&
                    //repetition === true &&
                    item.order -1 === prevColItem.order)
                {
                    let columnIndex;
                    let originOrder = item.order;
                    let mius = 2;
                    let tempcnt = 1;
                    while(true)
                    {
                        if(item.columnIndex - mius < 0 ||
                            originOrder - mius < 0)
                        {
                            break;
                        }

                        columnIndex = item.columnIndex - mius;

                        const tempItem = smalloadGraph[item.rowIndex][columnIndex];       
                        if(typeof tempItem  === 'undefined')
                        {
                            break;
                        }

                        if(originOrder - mius !== tempItem.order)
                        {
                            break;
                        }

                        tempcnt += 1;
                        mius += 1;
                    }

                    tempcnt += (item.rowIndex + 1);

                    if(lengthArr2[columnIndex + 1 - rowGap] + 1 === tempcnt)
                    { 
                        repetition = false;
                    }
                    else
                    {
                        repetition = true;
                    }
                }
             
                downGraphArr.push({
                    order: item.order,
                    repetition:repetition,
                    //repetition: typeof lastItem === 'undefined' ||
                    //    typeof targetItem !== 'undefined',
                });
            }
        }
    });
    return downGraphArr;
}

function generateNewDownRoad2Data(bigRoadGraph) {
    const maxColumnCount = Math.max(0, ...bigRoadGraph.map(row => row.length));
    const downGraphArr = [];
    const indexArr = [];
    const lengthArr = [];
    let beginIndex;
    {
        const item = bigRoadGraph[0][0];
        if (typeof item !== 'undefined') {
            beginIndex = item.order;
        }
        else {
            return downGraphArr;
        }
    }
    for (let columnIndex = 0; columnIndex < maxColumnCount; columnIndex++) {
        let currentLength = 0;
        for (let rowIndex = 0; rowIndex < bigRoadGraph.length; rowIndex++) {
            const item = bigRoadGraph[rowIndex][columnIndex];
            if (typeof item !== 'undefined') {
                currentLength += 1;
                indexArr.push({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    gameResult: bigRoadGraph[rowIndex][columnIndex].gameResult,
                    order: item.order,
                });
            }
        }
        lengthArr.push(currentLength);
    }
    indexArr.sort((a, b) => a.order - b.order);

    indexArr.forEach(item => {
        if (item.order >= beginIndex) {
            if (item.rowIndex === 0) {
                if(item.columnIndex >= 1)
                {
                    const lastItem = bigRoadGraph[item.rowIndex][item.columnIndex];
                    const lastItem2 = bigRoadGraph[item.rowIndex][item.columnIndex - 1];
                    if(lastItem.order - 1 === lastItem2.order)
                    {
                        downGraphArr.push({
                            order: item.order,
                            repetition: true,
                        });                        
                    }
                    else
                    {
                        downGraphArr.push({
                            order: item.order,
                            repetition: false,
                        });
                    }
                }
                else
                {
                    downGraphArr.push({
                        order: item.order,
                        repetition: false,
                    });
                }
            }
            else {
                const lastItem = bigRoadGraph[item.rowIndex - 1][item.columnIndex];
                const targetItem = bigRoadGraph[item.rowIndex][item.columnIndex];
                if(item.rowIndex === 1)
                {
                    downGraphArr.push({
                        order: item.order,
                        repetition:false,
                    });
                }
                else
                {
                    if(lastItem === undefined)
                    {
                        const lastItem2 = bigRoadGraph[item.rowIndex][item.columnIndex-1];
                        if(lastItem2 === undefined)
                        {
                            downGraphArr.push({
                                order: item.order,
                                repetition:false,
                            });
                        }
                        else
                        {
                            if(targetItem.order - 1 === lastItem2.order)
                            {
                                downGraphArr.push({
                                    order: item.order,
                                    repetition:true,
                                });    
                            }
                            else
                            {
                                downGraphArr.push({
                                    order: item.order,
                                    repetition:false,
                                });    
                            }
                        }
                    }
                    else
                    {
                        if(targetItem.order - 1=== lastItem.order)
                        {
                            downGraphArr.push({
                                order: item.order,
                                repetition:true,
                            });    
                        }
                        else
                        {
                            downGraphArr.push({
                                order: item.order,
                                repetition:false,
                            });    
                        }
                    }
                }
            }
        }
    });
    return downGraphArr;
}

class DownRoad extends Road {
    getPrediction(fakeNextRound, downRoadGap) {
        const fakeRoundResults = this.roundResults.map(result => RoundResult.from(result));
        fakeRoundResults.push(fakeNextRound);
        const fakeBigRoad = new SharedBigRoad(this.row, this.column, fakeRoundResults);
        const fakeDownRoadData = generateDownRoadData(fakeBigRoad.rawArray, downRoadGap);
        if(fakeDownRoadData.length == 0)
        {
          return undefined;
        }
        const fakeNextDownRoadItem = fakeDownRoadData[fakeDownRoadData.length - 1];
        return fakeNextDownRoadItem ? fakeNextDownRoadItem.repetition : undefined;
    }
}

export {DownRoad, generateDownRoadData, generateNewDownRoadData, generateNewDownRoad2Data}
